import React, { MouseEvent } from "react";
import { ModalProps } from "antd";
import CameraComponent, { ICameraComponent } from "../CameraComponent";
import { DocumentUploadConstants } from "../../constants/shared/documentUploadConstants";
import AntdModal from "../AntdModal";
import { ICapturedFile } from "../CameraComponent/index";

const { TAKE_PICTURE } = DocumentUploadConstants;

export interface ICameraModalProps extends ModalProps {
  title?: string;
  onSave?: (capturedFile?: ICapturedFile) => void | undefined;
  closeCameraModal?: (event?: MouseEvent) => void;
  cameraComponentProps?: ICameraComponent;
}

const CameraModal = (props?: ICameraModalProps) => {
  const {
    onSave,
    visible,
    closeCameraModal,
    title = TAKE_PICTURE,
    cameraComponentProps,
    ...modalProps
  } = props || {};

  return (
    <AntdModal
      visible={visible}
      onCancel={closeCameraModal}
      forceRender={true}
      title={title}
      maskClosable
      footer={null}
      {...modalProps}
    >
      <CameraComponent
        isVisible={visible}
        onSave={onSave}
        closeCamera={closeCameraModal}
        {...cameraComponentProps}
      />
    </AntdModal>
  );
};

export default CameraModal;
